import '../stylesheets/application.css'

// Turbo Drive: ページ遷移を瞬時化（リロードなし＝アプリ感）。SEO/OGP は維持。
import '@hotwired/turbo'

import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import DocsPanel from '../components/DocsPanel.jsx'
import ReactionBar from '../components/ReactionBar.jsx'
import FollowButton from '../components/FollowButton.jsx'
import StudioInventory from '../components/StudioInventory.jsx'
import OpsBoard from '../components/OpsBoard.jsx'

// data-react-island="名前" の要素にマウントする React 島
const ISLANDS = {
  docs: DocsPanel,
  reactions: ReactionBar,
  follow: FollowButton,
  'studio-inventory': StudioInventory,
  'ops-board': OpsBoard,
}

const roots = new WeakMap()

// Turbo 遷移のたびにマウント（turbo:load は初回ロードでも発火）
function mountIslands() {
  document.querySelectorAll('[data-react-island]').forEach((el) => {
    if (roots.has(el)) return
    const Comp = ISLANDS[el.dataset.reactIsland]
    if (!Comp) return
    const root = createRoot(el)
    roots.set(el, root)
    root.render(createElement(Comp, { dataset: { ...el.dataset } }))
  })
}

// Turbo がページをキャッシュする前に React を片付ける（古いDOM混入を防ぐ）
function unmountIslands() {
  document.querySelectorAll('[data-react-island]').forEach((el) => {
    const root = roots.get(el)
    if (root) {
      root.unmount()
      roots.delete(el)
    }
  })
}

document.addEventListener('turbo:load', mountIslands)
document.addEventListener('turbo:before-cache', unmountIslands)
